(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const variants = form.querySelector('[name="id"]');
    const main = root.querySelector('[data-bea-main]');
    const sticky = root.querySelector('[data-bea-sticky]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const presets = form.querySelectorAll('[name="bea_preset"]');
    const picture = root.querySelector('[data-bea-variant-image]');
    const originalPicture = picture ? { src: picture.getAttribute('src'), alt: picture.alt } : null;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-CH', {
      style: 'currency', currency: root.dataset.currency || 'CHF'
    });
    presets.forEach(preset => preset.addEventListener('change', () => {
      if (preset.checked) quantityInput.value = preset.value;
      update();
    }));
    form.querySelectorAll('[data-quantity-step]').forEach(button => {
      button.addEventListener('click', () => {
        const current = quantityInput.validity.valid ? quantityInput.valueAsNumber : 1;
        quantityInput.value = Math.max(1, current + Number(button.dataset.quantityStep));
        update();
      });
    });
    quantityInput.addEventListener('input', update);
    function update() {
      const option = variants.selectedOptions[0];
      const quantity = quantityInput.valueAsNumber;
      const valid = quantityInput.validity.valid && Number.isSafeInteger(quantity);
      presets.forEach(preset => { preset.checked = valid && Number(preset.value) === quantity; });
      form.querySelector('[data-quantity-step="-1"]').disabled = !valid || quantity <= 1;
      const price = Number(option.dataset.price);
      const total = Math.round(price * quantity * (quantity >= 2 ? 1 - Number(root.dataset.discount || 0) / 100 : 1));
      root.querySelectorAll('[data-bea-total]').forEach(el => {
        el.textContent = valid ? formatter.format(total / 100) : '–';
      });
      root.querySelector('[data-bea-count]').textContent = valid ? quantity + ' ' + (quantity === 1 ? (root.dataset.unitSingle || 'Stück') : (root.dataset.unitPlural || 'Stück')) : 'Menge wählen';
      root.querySelectorAll('[data-bea-variant-label]').forEach(el => {
        el.textContent = option.dataset.label || option.textContent;
      });
      root.querySelectorAll('[data-bea-compare]').forEach(el => {
        const compare = Number(option.dataset.compare || 0);
        el.hidden = !valid || compare <= price;
        el.replaceChildren();
        if (!el.hidden) {
          const oldPrice = document.createElement('s');
          oldPrice.textContent = formatter.format(compare * quantity / 100);
          el.append('Regulär ', oldPrice);
        }
      });
      root.querySelectorAll('button[name="add"]').forEach(button => {
        button.disabled = option.dataset.available !== 'true' || !valid;
        button.textContent = option.dataset.available !== 'true' ? 'Ausverkauft' : (!valid ? 'Menge wählen' : 'In den Warenkorb');
      });
    }
    function updateVariant() {
      const option = variants.selectedOptions[0];
      if (picture && originalPicture) {
        picture.src = option.dataset.image || originalPicture.src;
        picture.alt = option.dataset.imageAlt || originalPicture.alt;
      }
      update();
    }
    variants.addEventListener('change', () => {
      updateVariant();
      if (root.dataset.productUrl && window.history && window.location) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variants.value);
        window.history.replaceState({}, '', url);
      }
    });
    form.addEventListener('change', update);
    update();
    // Respect a shared variant link without replacing the default chalk image on first load.
    if (window.location && new URL(window.location.href).searchParams.has('variant')) updateVariant();
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        sticky.hidden = entries[0].isIntersecting;
      });
      observer.observe(main);
      document.addEventListener('shopify:section:unload', e => {
        if (e.target.contains(root)) observer.disconnect();
      });
    }
  }
  function scan() { document.querySelectorAll('[data-bea-product]').forEach(init); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
